module.exports = __webpack_public_path__ + "8001549ba3442c6c3edf37753c87d870.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/I3@2x.png
// module id = 809
// module chunks = 0